<template>
    <div>
        <div class="d-flex align-items-center flex-wrap mt-3 mb-4">
            <div class="custom-control custom-radio custom-control-v2 mr-2 mb-2" v-for="(item, date) in items">
                <input type="radio" :id="'date-' + date" v-model="data.date.key" :value="date" class="custom-control-input">
                <label class="custom-control-label d-flex align-items-center" :for="'date-' + date">
                    <img class="custom-control-icon" src="/img/calendar.svg" alt="" style="height: 14px;">
                    <span class="text-muted ml-2" v-html="item.display_date_from"></span>
                </label>
            </div>
        </div>

        <div class="table-responsive mb-3" v-if="data.date && filteredItems">
            <table class="table table-striped table-hover mb-0">
                <thead>
                    <tr>
                        <th scope="col" class="text-uppercase">Aranžman</th>
                        <th scope="col" class="text-uppercase text-right">Cijena aranžmana po osobi</th>
                        <th scope="col" class="text-uppercase text-right">Broj polaznika</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, itemKey) in filteredItems">
                        <tr>
                            <td>
                                <span v-html="item.name"></span>
                                <small class="d-block" v-if="item.description" v-html="item.description"></small>
                            </td>
                            <td class="text-right">
                                <span v-if="
                                    item.price.price_type == 'first_minute' ||
                                    item.price.price_type == 'last_minute' ||
                                    item.price.price_type == 'special'
                                "
                                      class="d-block text-muted font-weight-bold"
                                      style="font-size: .875em;">
                                    <del v-html="$priceFormat(getRegularPrice(item))"></del>
                                </span>
                                <span class="text-primary font-weight-bold" v-html="$priceFormat(item.price.amount)"></span>
                            </td>
                            <td class="text-right">
                                <select class="custom-select custom-select-sm" style="width: auto;" @change="setData(itemKey, $event)">
                                    <option value="0" selected>0</option>
                                    <option :value="n" v-for="n in 3" v-html="n"></option>
                                </select>
                            </td>
                        </tr>
                        <tr v-if="! _.isEmpty(data.items) && _.has(data.items, itemKey)" v-for="(d, i) in data.items[itemKey]" style="background-color: transparent;">
                            <td colspan="3">
                                <div class="form-inline">
                                    <span class="font-weight-bold" v-html="'Polaznik ' + i"></span>
                                    <label for="" class="ml-5 mr-2">Godine polaznika:</label>
                                    <select class="form-control form-control-sm mr-1" v-model="d.age">
                                        <option :value="y" v-for="y in $range(d.min, d.max)" v-html="y"></option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <div class="d-flex align-items-end justify-content-lg-end mb-4">
            <button type="button" class="btn btn-primary" :disabled="! isValidated" @click="submit($event)">Pošalji upit</button>
        </div>
    </div>
</template>

<script>
export default {
    components: {},

    props: {
        item: {
            type: Object,
            required: true
        },
        items: {
            type: Object,
            required: true
        },
        firstDateFrom: {
            type: String,
            required: true
        },
        firstDateTo: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            data: {},
            cart: {}
        }
    },

    computed: {
        filteredItems: function () {
            if (this.data.date) {
                let items = this.items[this.data.date.key].items

                return items
            }
        },

        isValidated: function () {
            if (this.data.date && ! _.isEmpty(this.data.items)) {
                return true
            }

            return false
        }
    },

    beforeMount() {
        Vue.set(this.data, 'slug', this.item.slug)
        Vue.set(this.data, 'type', 'course-grp')
        Vue.set(this.data, 'items', {})
        Vue.set(this.data, 'date', {
            key: this.firstDateFrom + '|' + this.firstDateTo,
        })
    },

    watch: {
        "data.items": {
            handler: function () {},
            deep: true
        },

        "data.date": {
            handler: function () {
                if (! _.isEmpty(this.data.items)) {
                    this.data.items = {}
                    document.querySelector('table select').value = 0
                }
            },
            deep: true
        }
    },

    methods: {
        setData(key, e) {
            let n = e.srcElement.value,
                item = this.filteredItems[key]

            if (n > 0 && item) {
                this.$set(this.data.items, key, {})

                for(let i = 1; i <= n; i ++) {
                    this.$set(this.data.items[key], i, {
                        age: parseInt(item.age.min),
                        min: parseInt(item.age.min),
                        max: parseInt(item.age.max)
                    })
                }
            } else {
                this.$delete(this.data.items, key)
            }
        },

        errResponse(type) {
            // if (type == 'week') {
            //     alert('Odabrani broj tjedana mora odgovarati za odabranu cijenu i smještaj.')
            // }
        },

        getRegularPrice(item) {
            let value2

            $.each(item.options, function(key, value) {
                if (value.type == 'regular') {
                    value2 = value.amount
                }
            });

            return value2
        },

        submit(e) {
            let btn = e.target

            btn.disabled = true

            axios.post('/naplata', this.data)
                .then(function (response) {
                    if (response.data.status == 'success') {
                        window.location.href = '/naplata'
                    } else {
                        btn.disabled = false
                    }
                })
                .catch(function (error) {
                    btn.disabled = false
                })
        }
    }
}
</script>
